import { objectDecoder, stringDecoder } from "json-decoder";
import { EnvSettings } from "../domain/envSettings";

export const envDecoder = objectDecoder<EnvSettings>({
  serviceHost: stringDecoder,
});
